import { createAction, props } from "@ngrx/store";
import { IUnidade } from "src/app/shared/interfaces/unidade/iunidade";
import { IUnitTaxInfo } from "src/app/shared/interfaces/unidade/iunittaxinfo";

enum UnidadeActionType {
    LOAD_UNIDADE = '[unidade] load unidade from api',
    LOAD_UNIDADE_SUCCESS = '[unidade] load unidade from api return success',
    LOAD_UNIDADE_ERROR = '[unidade] load unidade from api return error',

    SAVE_UNIDADE = '[unidade] save unidade from api',
    SAVE_UNIDADE_SUCCESS = '[unidade] save unidade from api return success',
    SAVE_UNIDADE_ERROR = '[unidade] save unidade from api return error',

    EDIT_UNIDADE = '[unidade] edit units information in the api',
    EDIT_UNIDADE_SUCCESS = '[unidade] edit units information in the api return success',
    EDIT_UNIDADE_ERROR = '[unidade] edit units information in the api return error',

    DELETE_UNIDADE = '[unidade] delete unidade from api',
}

export const loadUnidade = createAction(
    UnidadeActionType.LOAD_UNIDADE
)

export const loadUnidadeSuccess = createAction(
    UnidadeActionType.LOAD_UNIDADE_SUCCESS,
    props<{ lista: IUnidade[] }>()
)

export const loadUnidadeError = createAction(
    UnidadeActionType.LOAD_UNIDADE_ERROR
)

export const saveUnidade = createAction(
    UnidadeActionType.SAVE_UNIDADE,
    props<{ unidade: IUnidade }>()
)

export const saveUnidadeSuccess = createAction(
    UnidadeActionType.SAVE_UNIDADE_SUCCESS,
    props<{ unidade: any }>()
)

export const saveUnidadeError = createAction(
    UnidadeActionType.SAVE_UNIDADE_ERROR,
    props<{ error: any }>()
)

export const editUnidade = createAction(
    UnidadeActionType.EDIT_UNIDADE,
    props<{ unidade: IUnitTaxInfo | IUnidade; id: number }>()
);

export const editUnidadeSuccess = createAction(
    UnidadeActionType.EDIT_UNIDADE_SUCCESS,
    props<{ unidade: any }>()
);

export const editUnidadeError = createAction(
    UnidadeActionType.EDIT_UNIDADE_ERROR
);

export const deleteUnidade = createAction(
    UnidadeActionType.DELETE_UNIDADE,
    props<{ id: number }>()
);
